import { render, staticRenderFns } from "./ArrowLeftIcon.vue?vue&type=template&id=3ab7e74c"
import script from "./ArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./ArrowLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports